// issues on selecting the company
// total calculating in the same page for everything

import React, { useState, useEffect } from 'react'
import EmployerHeader from '../components/EmployerHeader'
import EditInvoice from '../components/EditInvoice'
import '../assets/css/employer-page.css'
import useAxios from '../utils/useAxios'

function EmployerPage({is_reviewer}) {

    let [invoices, setInvoices] = useState([])
    let [total, setTotal] = useState(0)
    let [totalAgree, setTotalAgree] = useState(0)
    let [totalDisagree, setTotalDisagree] = useState(0)
    let [companies, setCompanies] = useState([])
    let [invoiceFiles, setInvoiceFiles] = useState([])

    let [users, setUsers] = useState([])
    let [userFilter, setUserFilter] = useState("all")
    let [filterdInvoices, setFilteredInvoices] = useState([])
    
    let [categories, setCategories] = useState([])
    let [categoryFilter, setCategoryFilter] = useState('all')

    let [atDate, setAtDate] = useState(false)
    let [fromDateFilter, setFromDateFilter] = useState("1900-01-01")
    let [toDateFilter, setToDateFilter] = useState("2100-01-01")

    let [currencies, SetCurrencies] = useState([])

    let [currenciesTotalArray, setCurrenciesTotalArray] = useState([])

    const [search, setSearch] = useState('')

    const [isCompanyInvoices, setIsCompanyInvoices] = useState(false)

    let [counter, setCounter] = useState(0)


    let [invoiceToEdit, setInvoiceToEdit] = useState({})
    let [invoiceToEditCategories, setInvoiceToEditCategories] = useState({})

    let [selectedRows, setSelectedRows] = useState([])

    let [sortedById, setSortedById] = useState(false)
    let [sortedByDate, setSortedByDate] = useState(false)

    const sort_up_icon = "M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
    const sort_down_icon = "M3.5 3.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 12.293V3.5zm4 .5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm0 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5zM7 12.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5z"
    const [sortIdIcon, setSortIdIcon] = useState(sort_down_icon)
    const [sortDateIcon, setSortDateIcon] = useState(sort_down_icon)

    const [isSortedClicked, setIsSortedClicked] = useState(false)
    const [isSortedOnId, setIsSortedOnId] = useState(true)

    const [nextUrl, setNextUrl] = useState([])
    const [previousUrl, setPreviousUrl] = useState([])

    const [currentPage, setCurrentPage] = useState('/api/invoice/?page=1')

    const [allInvoicesTotal, setAllInvoicesTotal] = useState(null)

    const [allRecordsSelected, setAllRecordsSelected] = useState(false)

    let api = useAxios()

    const baseURL = "http://hamsieexpenses.com"

    function financial(x) {
        return Number.parseFloat(x).toFixed(2);
    }

    function financial1(x) {
        return x.toLocaleString('en-US')
    }

    useEffect(() => {
        if (isCompanyInvoices === false) {
            getCompanies()
            getInvoices()
            getTotal()
            // if (isSortedClicked) {
            //     console.log("yes entered here")
            //     if(isSortedOnId) {
            //         handleIdSortEffect()
            //     } else {
            //         handleDateSortEffect()
            //     }
            // }
        } else if (isCompanyInvoices === true) {
            companyInvoices()
            getTotal()
            getCompanies()
            // if (isSortedClicked) {
            //     if(isSortedOnId) {
            //         handleIdSortEffect()
            //     } else {
            //         handleDateSortEffect()
            //     }
            // }
        }
        
    }, [counter])

    useEffect(() => {
        getCurrencies()
        getAllInvoicesTotal()
    }, [])

    useEffect(() => {
        getTotal()
    })

    // useEffect(() => {
    //     let currentFilteredInvoices = []
    //     invoices.forEach((invoice) => {
    //         if (userFilter === 'all') {
    //             currentFilteredInvoices = invoices
    //         }
    //         else if (invoice.employee === userFilter) {
    //             currentFilteredInvoices.push(invoice)
    //         }
    //     })
    //     setFilteredInvoices(currentFilteredInvoices)
    // }, [userFilter])

    let getAllInvoicesTotal = async () => {
        let response = await api.get('/api/curruncies-total/')
        if (response.status == 200) {
            setAllInvoicesTotal(response.data)
        }
    }

    let getCurrencies = async () => {
        let response = await api.get('/api/money-types/')
        if (response.status === 200) {
            SetCurrencies(response.data)
        }
    }

    let getInvoicesForHandler = async (url) => {
        let response = await api.get(url)
        if (response.status === 200) {

            setInvoices(response.data.results)
            setFilteredInvoices(response.data.results)
            setIsCompanyInvoices(false)

            setNextUrl(response.data.next)
            setPreviousUrl(response.data.previous)

            let array = response.data.results
            let usersArray = []
            let categoriesArray = []
            array.forEach(element => {
                if (!usersArray.includes(element.employee)) {
                    usersArray.push(element.employee)
                }
                if (!categoriesArray.includes(element.category)) {
                    categoriesArray.push(element.category)
                }
            })
            setUsers(usersArray)
            setCategories(categoriesArray)
            // if (isSortedClicked) {
            //     console.log("sortedClicked", isSortedClicked)
            //     if(isSortedOnId) {
            //         console.log("is sorted on id", isSortedOnId)
            //         handleIdSortEffect()
            //     } else {
            //         handleDateSortEffect()
            //     }
            // }
        }
    }

    let getInvoices = async () => {
        let response = await api.get(currentPage)
        if (response.status === 200) {

            setInvoices(response.data.results)
            setFilteredInvoices(response.data.results)
            setIsCompanyInvoices(false)

            setNextUrl(response.data.next)
            setPreviousUrl(response.data.previous)

            let array = response.data.results
            let usersArray = []
            let categoriesArray = []
            array.forEach(element => {
                if (!usersArray.includes(element.employee)) {
                    usersArray.push(element.employee)
                }
                if (!categoriesArray.includes(element.category)) {
                    categoriesArray.push(element.category)
                }
            })
            setUsers(usersArray)
            setCategories(categoriesArray)
            // if (isSortedClicked) {
            //     console.log("sortedClicked", isSortedClicked)
            //     if(isSortedOnId) {
            //         console.log("is sorted on id", isSortedOnId)
            //         handleIdSortEffect()
            //     } else {
            //         handleDateSortEffect()
            //     }
            // }
        } 
        
    }

    let getTotal = async () => {
        total = 0
        totalAgree = 0
        totalDisagree = 0
        invoices.forEach(invoice => {
            if (invoice.is_archived === false) {
                total += invoice.total_amount_of_invoice
                if (invoice.is_agree === true) {
                    totalAgree += invoice.total_amount_of_invoice
                } else if (invoice.is_agree === false && invoice.is_agree1 === true) {
                    totalDisagree += invoice.total_amount_of_invoice
                }
            }
        });
        setTotal(total)
        setTotalAgree(totalAgree)
        setTotalDisagree(totalDisagree)
    }

    let getCompanies = async () => {
        let response = await api.get('/api/companies/')
        if (response.status === 200) {
            
            setCompanies(response.data)
            setIsCompanyInvoices(true)

        }
    }

    let setAgree = async (id) => {
        let response = await api.patch('/api/invoice/' + id, {
            'is_agree': true,
        })
        if (response.status === 200) {
            setCounter(counter + 1)
            // alert("You agreed the invoice")
        } else {
            alert("Sorry something went wrong")
        }

    }

    let setDisagree = async (id) => {
        let response = await api.patch('/api/invoice/' + id, {
            'is_agree': false,
            'is_agree1': true,
        })
        if (response.status === 200) {
            setCounter(counter + 1)
            // alert("You disagreed the invoice")
        } else {
            alert("Sorry something went wrong")
        }
    }

    let setArchived = async (id) => {
        let response = await api.patch('/api/invoice/' + id, {
            'is_archived': true
        })
        if (response.status === 200) {
            setCounter(counter + 1)
            // alert("You Archived the invoice")
        } else {
            alert("Sorry something went wrong")
        }
    }

    let companyInvoices = async (id) => {
        let response = await api.get('/api/company-invoices/' + id)
        if (response.status === 200) {
            setInvoices(response.data)

            let array = response.data
            let usersArray = []
            let categoriesArray = []
            array.forEach(element => {
                if (!usersArray.includes(element.employee)) {
                    usersArray.push(element.employee)
                }
                if (!categoriesArray.includes(element.category)) {
                    categoriesArray.push(element.category)
                }
            })
            setUsers(usersArray)
            setCategories(categoriesArray)
        }
    }

    let getInvoiceFiles = async (id) => {
        let response = await api.get('/api/invoice-files/' + id)
        if (response.status === 200) {
            setInvoiceFiles(response.data)
        }
    }


    const getTotalForCurrency = (currency) => {
        let currencyTotal = 0
        invoices.forEach(invoice => {
            if (invoice.is_archived === false) {
                if (invoice.amount_money_type === currency) {
                    currencyTotal += invoice.total_amount_of_invoice
                }
            }
        })
        return currencyTotal
    }

    const getTotalForDisagreedCurrency = (currency) => {
        let currencyTotal = 0
        invoices.forEach(invoice => {
            if (invoice.is_archived === false) {
                if (invoice.amount_money_type === currency && invoice.is_agree === false && invoice.is_agree1 === true) {
                    currencyTotal += invoice.total_amount_of_invoice
                }
            }
        })
        return currencyTotal
    }

    const getTotalForAgreedCurrency = (currency) => {
        let currencyTotal = 0
        invoices.forEach(invoice => {
            if (invoice.is_archived === false) {
                if (invoice.amount_money_type === currency && invoice.is_agree === true) {
                    currencyTotal += invoice.total_amount_of_invoice
                }
            }
        })
        return currencyTotal
    }

    let patchInvoice = async (e) => {
        e.preventDefault()
        let current_invoice_files = []
        for (let i = 0; i < e.target.invoice_files.files.length; i++) {
            current_invoice_files.push(e.target.invoice_files.files[i])
        }
        let response = await api.patch('/api/invoice/' + invoiceToEdit.id, {
            'name': e.target.name.value,
            'description': e.target.description.value,
            'invoice_date': e.target.invoice_date.value,
            // 'invoice_image': e.target.invoice_image.files[0],
            'invoice_files': current_invoice_files,
            'total_amount_of_invoice': e.target.total_amount_of_invoice.value,
            'amount_money_type': e.target.amount_money_type.value,
            'category': e.target.category.value,
            'is_agree1': false,
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })

        if (response.status === 200) {
            alert("Invoice Edited Successfully")
        } else {
            alert("Please try again something went wrong")
        }

        setCounter(counter + 1)
    }



    let getTotalWithCurrencies = () => {
        let currenciesTotalArray1 = []
        currencies.forEach(currency => {
            let total1 = 0
            let agreedTotal1 = 0
            let disagreedTotal1 = 0
            filterdInvoices.forEach(invoice => {
                
                if (invoice.is_archived === false) {
                    if (invoice.amount_money_type === currency.name) {
                        total1 += invoice.total_amount_of_invoice
                        if (invoice.is_agree === true) {
                            agreedTotal1 += invoice.total_amount_of_invoice
                        } else if (invoice.is_agree === false && invoice.is_agree1 === true) {
                            disagreedTotal1 += invoice.total_amount_of_invoice
                        }
                    }
                }
            })
            currenciesTotalArray1.push({
                'currency': currency.name,
                'total1': total1,
                'agreedTotal1': agreedTotal1,
                'disagreedTotal1': disagreedTotal1
            })
        })
        setCurrenciesTotalArray(currenciesTotalArray1)
    }

    let editInvoiceData = async (id) => {
        let currentInvoiceToEdit = invoices.find((invoice) => invoice.id === id)
        setInvoiceToEdit(currentInvoiceToEdit)
        let response = await api.get('/api/invoice-categories/' + id)
        if (response.status === 200) {
            setInvoiceToEditCategories(response.data)
        }
    }

    let checkBoxFired = async (id) => {
        if (selectedRows.includes(id)) {
            const updatedItems = selectedRows.filter(item => item !== id);
            setSelectedRows(updatedItems)
        } else {
            setSelectedRows([...selectedRows, id])
        }
    }

    let selectAllRecords = async () => {
        let records = document.getElementsByClassName('invoices-check-box')
        let newArr = []
        for (let i = 0; i < records.length; i++) {
            let my_number = parseInt(records[i].id.slice(15));
            newArr.push(my_number)
            records[i].click()
        }
        setSelectedRows(newArr)
    }

    // function agreeAllFired1 () {
    //     return new Promise((resolve, reject) => {
    //         const newSelectedRows = selectedRows
    //         console.log("this is new selectedRows", newSelectedRows)
    //         newSelectedRows.forEach((item) => {
    //             setAgree(item)
    //             setCounter(counter + 1)
    //         })
    //         let selectedCheckedBox = document.getElementsByclassName('form-check-input')
    //         for (let sCB=0; sCB < selectedCheckedBox.length; sCB++) {
    //             selectedCheckedBox[sCB].checked = false
    //             setCounter(counter + 1)
    //         }
    //         setSelectedRows([])
    //         resolve()
    //     });

    // }


    // let agreeAllFired = () => {
    //     agreeAllFired1().then(() => {
    //         setCounter(counter + 1)
    //     })
    // }

    let agreeAllFired = async () => {
        let response = await api.patch('/api/agree-multiple-invoices/', {
            'invoice_ids': selectedRows,
            'is_agree': true
        })
        if (response.status === 200) {
            setCounter(counter + 1)
            let records = document.getElementsByClassName('form-check-input')
            for (let i = 0; i < records.length; i++) {
                records[i].checked = false
            }
            setSelectedRows([])
        } else {
            alert("Sorry something went wrong")
        }
    }


    let disAgreeAllFired = async () => {
        let response = await api.patch('/api/disagree-multiple-invoices/', {
            'invoice_ids': selectedRows,
            'is_agree': false,
            'is_agree1': true
        })
        if (response.status === 200) {
            setCounter(counter + 1)
            let records = document.getElementsByClassName('form-check-input')
            for (let i = 0; i < records.length; i++) {
                records[i].checked = false
            }
            setSelectedRows([])
        } else {
            alert("Sorry something went wrong")
        }
    }

    // function disAgreeAllFired() {
    //     const newSelectedRows = selectedRows
    //     newSelectedRows.forEach((item) => {
    //         setDisagree(item)
    //     })
    //     let selectedCheckedBox = document.getElementsByclassName('form-check-input')
    //     for (let sCB=0; sCB < selectedCheckedBox.length; sCB++) {
    //         selectedCheckedBox[sCB].checked = false
    //     }
    //     setSelectedRows([])
    // }

    let archivedAllFired = async () => {
        let response = await api.patch('/api/archive-multiple-invoices/', {
            'invoice_ids': selectedRows,
            'is_archive': true
        })
        if (response.status === 200) {
            setCounter(counter + 1)
            let records = document.getElementsByClassName('form-check-input')
            for (let i = 0; i < records.length; i++) {
                records[i].checked = false
            }
            setSelectedRows([])
        } else {
            alert("Sorry something went wrong")
        }
    }

    let resetAllFired = async () => {
        let response = await api.patch('/api/reset-multiple-invoices/', {
            'invoice_ids': selectedRows,
            'is_agree': false,
            'is_agree1': false
        })
        if (response.status === 200) {
            setCounter(counter + 1)
            let records = document.getElementsByClassName('form-check-input')
            for (let i = 0; i < records.length; i++) {
                records[i].checked = false
            }
            setSelectedRows([])
        } else {
            alert("Sorry something went wrong")
        }
    }

    

    const handleIdSort = () => {
        if (sortedById) {
            const newInvoices = [...invoices]
            newInvoices.sort((a, b) => b.id - a.id)
            setInvoices(newInvoices)
            setSortedById(!sortedById)
            setSortIdIcon(sort_down_icon)
            setIsSortedClicked(true)
            setIsSortedOnId(true)
        } else if (!sortedById) {
            const newInvoices = [...invoices]
            newInvoices.sort((a, b) => a.id - b.id)
            setInvoices(newInvoices)
            setSortedById(!sortedById)
            setSortIdIcon(sort_up_icon)
            setIsSortedClicked(true)
            setIsSortedOnId(true)
        }
    }

    const handleIdSortEffect = () => {
        if (!sortedById) {
            const newInvoices = [...invoices]
            newInvoices.sort((a, b) => b.id - a.id)
            setInvoices(newInvoices)
        } else if (sortedById) {
            const newInvoices = [...invoices]
            newInvoices.sort((a, b) => a.id - b.id)
            setInvoices(newInvoices)
        }
    }

    const handleDateSort = () => {
        if (sortedByDate) {
            const newInvoices = [...invoices]
            newInvoices.sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date))
            setInvoices(newInvoices)
            setSortedByDate(!sortedByDate)
            setSortDateIcon(sort_down_icon)
            setIsSortedClicked(true)
            setIsSortedOnId(false)
        } else if (!sortedByDate) {
            const newInvoices = [...invoices]
            newInvoices.sort((a, b) => new Date(a.invoice_date) - new Date(b.invoice_date))
            setInvoices(newInvoices)
            setSortedByDate(!sortedByDate)
            setSortDateIcon(sort_up_icon)
            setIsSortedClicked(true)
            setIsSortedOnId(false)
        }
    }

    const handleDateSortEffect = () => {
        if (!sortedByDate) {
            const newInvoices = [...invoices]
            newInvoices.sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date))
            setInvoices(newInvoices)
        } else if(sortedByDate) {
            const newInvoices = [...invoices]
            newInvoices.sort((a, b) => new Date(a.invoice_date) - new Date(b.invoice_date))
            setInvoices(newInvoices)
        }
    }

    // function archivedAllFired() {
    //     selectedRows.forEach((item) => {
    //         setArchived(item)
    //     })
    //     let selectedCheckedBox = document.getElementsByclassName('form-check-input')
    //     for (let sCB=0; sCB < selectedCheckedBox.length; sCB++) {
    //         selectedCheckedBox[sCB].checked = false
    //     }
    //     setSelectedRows([])
    // }

    const paginationHandler = (url) => {
        setCurrentPage(url)
        if (isCompanyInvoices) {
            companyInvoices()
        } else if (!isCompanyInvoices) {
            getInvoicesForHandler(url)
        }
    } 

    useEffect(() => {
        setFilteredInvoices(invoices.filter((item) => {
            if (search.toLowerCase() === "") {
                return item
            } else if (item.name.toLowerCase().includes(search)) {
                return item
            } else if (String(item.id).toLowerCase().includes(search)) {
                return item
            } else if (item.description.toLowerCase().includes(search)) {
                return item
            } else if (item.employee.toLowerCase().includes(search)) {
                return item
            } else if (item.category.toLowerCase().includes(search)) {
                return item
            } else if (String(item.amount).toLowerCase().includes(search)) {
                return item
            } else if (item.amount_money_type.toLowerCase().includes(search)) {
                return item
            }
        }).filter((item) => {
            if (userFilter === 'all') {
                return item
            } else if (userFilter === item.employee) {
                return item
            }
        }).filter((item) => {
            if (categoryFilter === 'all') {
                return item
            } else if (categoryFilter === item.category) {
                return item
            }
        }).filter((item) => {
            if (atDate === false) {
                return item
            } else {
                if (new Date(item.invoice_date) >= new Date(fromDateFilter) && new Date(item.invoice_date) <= new Date(toDateFilter)) {
                    return item
                }
            }
        }))
        getTotalWithCurrencies()
    }, [JSON.stringify(filterdInvoices), search, userFilter, toDateFilter, fromDateFilter, categoryFilter])

  return (
    <div>
        <EmployerHeader is_reviewer={is_reviewer}/>
        <div className='container'>
            {/* <button className='btn btn-primary' onClick={handleIdSortEffect}>id</button>
            <button className='btn btn-primary' onClick={handleDateSortEffect}>date</button> */}
            <div className="d-flex justify-content-between">
                <div><h2>All Invoices</h2></div>
                {/* <div><button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal">Add Invoice</button></div> */}
            </div>

            <div className="d-flex">
                <div className='me-auto'><h4>Companies</h4></div>
                {companies.map(company => (
                    <div key={company.id}><button className='btn btn-outline-dark me-2' onClick={() => companyInvoices(company.id)}>{company.name}</button></div>
                ))}
            </div>

            <div className='row d-flex mt-4'>
                <h2>All Invoices Total amount on each currency</h2>
                {allInvoicesTotal && allInvoicesTotal.map((element, index) => (
                        <div className='col-md-3 col text-satrt' key={index}>
                        <h4 className='text-danger'>{element.name}</h4>
                        <h5>Total: <span className='text-danger'>{financial1(element.total)}</span></h5>
                    </div>
                    
                ))}
            </div>

            <div className='row d-flex mt-4'>
                <h2>Total amount on each currency for this selection</h2>
                {currenciesTotalArray && currenciesTotalArray.map((element, index) => (
                        <div className='col-md-3 col text-satrt' key={index}>
                        <h4 className='text-danger'>{element.currency}</h4>
                        <h5>Total: <span className='text-danger'>{financial1(element.total1)}</span></h5>
                        <h5>Total Agreed: <span className='text-danger'>{financial1(element.agreedTotal1)}</span></h5>
                        <h5>Total Disagreed: <span className='text-danger'>{financial1(element.disagreedTotal1)}</span></h5>
                    </div>
                    
                ))}
            </div>

            {/* <div className='row d-flex mt-4'>
                <div className='col text-start'>
                    <h2>Total Amount</h2>
                    {currencies.map(currency => (
                        <h5 key={currency.id}>{currency.name} <span className='text-danger'>{financial(getTotalForCurrency(currency.name))}</span></h5>
                    ))}
                </div>
                <div className='col text-start'>
                    <h2>Total Agreed: </h2>
                    {currencies.map(currency => (
                        <h5 key={currency.id}>{currency.name} <span className='text-danger'>{financial(getTotalForAgreedCurrency(currency.name))}</span></h5>
                    ))}
                </div>
                <div className='col text-start'>
                    <h2>Total Disagreed: <span className='text-danger'>{financial(totalDisagree)}</span></h2>
                    {currencies.map(currency => (
                        <h5 key={currency.id}>{currency.name} <span className='text-danger'>{financial(getTotalForDisagreedCurrency(currency.name))}</span></h5>
                    ))}
                </div>
            </div> */}

        </div>


        <div className='container-fluid'>
            <form className="d-flex mt-5" role="search">
                <input onChange={(e) => setSearch(e.target.value)} className="form-control mr-sm-2 me-2" type="search" placeholder="Search Invoice" aria-label="Search" />
            </form>
        <div className='table-responsive-md'>
        <table className="table table-striped mt-2 table-responsive-md">
            <thead className='sticky-header'>
                <tr className='first-row-header'>
                <th scope="col" className='col'># <input className="form-check-input d-block" type="checkbox" value="" onChange={() => selectAllRecords()} style={{backgroundColor: '#333', borderColor: '#333', color: '#fff'}}/></th>
                <th scope="col" className='col-1'>User
                    <span className='m-1' onClick={handleIdSort} style={{color: "blue", cursor: "pointer"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-sort-up" viewBox="0 0 16 16">
                            <path d={sortIdIcon}/>
                        </svg>
                    </span>
                    <select className='form-select' onChange={(e) => setUserFilter(e.target.value)}>
                        <option value={"all"}>All Users</option>
                        {users.map((user, index) => (
                            <option key={index} value={user}>{user}</option>
                        ))}
                    </select>
                </th>
                <th scope="col" className='col-2'>Invoice Name</th>
                <th scope="col" className='col-2'>Description</th>
                <th scope="col" className='col-2'>Category
                    <select className='form-select' onChange={(e) => setCategoryFilter(e.target.value)}>
                        <option value={'all'}>All Categories</option>
                        {categories.map((category, index) => (
                            <option key={index} value={category}>{category}</option>
                        ))}
                    </select>
                </th>
                <th scope="col" className='col-1'>Date
                    <span className='m-1' onClick={handleDateSort} style={{color: "blue", cursor: "pointer"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-sort-up" viewBox="0 0 16 16">
                            <path d={sortDateIcon}/>
                        </svg>
                    </span>
                    <br></br>
                    <label>From:</label>
                    <input className='form-control' type="date" onChange={(e) => {setFromDateFilter(e.target.value); setAtDate(true)}} />
                    <label>To:</label>
                    <input className='form-control' type="date" onChange={(e) => {setToDateFilter(e.target.value); setAtDate(true)}} />
                </th>
                <th scope="col" className='col-3 text-center'>Invoice Files</th>
                <th scope="col" className='col-1'>Amount</th>
                <th scope='col' className='col'>Currency</th>
                <th scope="col" className='col'><button className='btn btn-success' onClick={() => agreeAllFired()}>Agree</button></th>
                <th scope='col' className='col'><button className='btn btn-danger' onClick={() => disAgreeAllFired()}>Disagree</button></th>
                {!is_reviewer && <th scope="col" className='col'><button className='btn btn-secondary' onClick={() => archivedAllFired()}>Archive</button></th>}
                {/* <th scope='col' className='col'><button className='btn btn-secondary' onClick={() => resetAllFired()}>Reset</button></th> */}
                <th scope='col'></th>
                </tr>
                <tr>
                    <th scope='col'></th>
                    <th scope='col'></th>
                    <th scope='col'></th>
                    <th scope='col'></th>
                    <th scope='col'></th>
                    <th scope='col'></th>
                    <th scope='col'></th>
                    <th scope='col'></th>
                    <th scope='col'></th>
                    <th scope='col' colSpan={4} className="md-block"><button className='btn btn-secondary w-100' onClick={() => resetAllFired()}>Reset</button></th>
                    
                </tr>
            </thead>
            
            <tbody>
                {invoices.filter((item) => {
                    if (search.toLowerCase() === "") {
                        return item
                    } else if (item.name.toLowerCase().includes(search)) {
                        return item
                    } else if (String(item.id).toLowerCase().includes(search)) {
                        return item
                    } else if (item.description.toLowerCase().includes(search)) {
                        return item
                    } else if (item.employee.toLowerCase().includes(search)) {
                        return item
                    } else if (item.category.toLowerCase().includes(search)) {
                        return item
                    } else if (String(item.amount).toLowerCase().includes(search)) {
                        return item
                    } else if (item.amount_money_type.toLowerCase().includes(search)) {
                        return item
                    }
                    {/* return search.toLowerCase() === "" ? item: item.name.toLowerCase().includes(search) */}
                }).filter((item) => {
                    if (userFilter === 'all') {
                        return item
                    } else if (userFilter === item.employee) {
                        return item
                    }
                }).filter((item) => {
                    if (categoryFilter === 'all') {
                        return item
                    } else if (categoryFilter === item.category) {
                        return item
                    }
                }).filter((item) => {
                    {/* let newFromDate = new Date(fromDateFilter)
                    let newToDate = new Date(toDateFilter)
                    let itemDate = new Date(item.invoice_date) */}
                    if (atDate === false) {
                        return item
                    } else {
                        if (new Date(item.invoice_date) >= new Date(fromDateFilter) && new Date(item.invoice_date) <= new Date(toDateFilter)) {
                            return item
                        }
                    }
                }).map(invoice => {
                    if (invoice.is_archived === false) {

                    
                    if (invoice.is_agree === true) {
                        return (
                            <tr className='table-success' key={invoice.id}>
                                <th scope="row">{invoice.id} <input id={'invoiceCheckBox' + invoice.id} className="form-check-input invoices-check-box" type="checkbox" value="" onClick={() => checkBoxFired(invoice.id)}/></th>
                                <td className='text-wrap'>{invoice.employee}</td>
                                <td>{invoice.name}</td>
                                <td>{invoice.description}</td>
                                <td>{invoice.category}</td>
                                <td>{invoice.invoice_date}</td>
                                <td className='text-center'><button className="btn btn-dark" data-bs-toggle="modal" data-bs-target="#filesModal" onClick={() => getInvoiceFiles(invoice.id)}>Show Files</button></td>
                                <td className='text-end'>{financial(invoice.total_amount_of_invoice)}</td>
                                <td>{invoice.amount_money_type}</td>
                                <td><button className="btn btn-success" onClick={() => setAgree(invoice.id)}>Agree</button></td>
                                <td><button className="btn btn-danger" onClick={() => setDisagree(invoice.id)}>Disagree</button></td>
                                {is_reviewer && <td></td>}
                                {!is_reviewer && <td><button className="btn btn-secondary" onClick={() => setArchived(invoice.id)}>Archive</button></td> }
                                {!is_reviewer && <td><button className='btn btn-secondary' data-bs-toggle="modal" data-bs-target="#editInvoiceModal" onClick={() => editInvoiceData(invoice.id)}>Edit</button></td> }
                            </tr>
                        )
                    } else if (invoice.is_agree === false && invoice.is_agree1 === true) {
                        return (
                            <tr className="table-danger" key={invoice.id}>
                                <th scope="row">{invoice.id} <input id={'invoiceCheckBox' + invoice.id} className="form-check-input invoices-check-box" type="checkbox" value="" onClick={() => checkBoxFired(invoice.id)}/></th>
                                <td>{invoice.employee}</td>
                                <td>{invoice.name}</td>
                                <td>{invoice.description}</td>
                                <td>{invoice.category}</td>
                                <td>{invoice.invoice_date}</td>
                                <td className='text-center'><button className="btn btn-dark" data-bs-toggle="modal" data-bs-target="#filesModal" onClick={() => getInvoiceFiles(invoice.id)}>Show Files</button></td>
                                <td className='text-end'>{financial(invoice.total_amount_of_invoice)}</td>
                                <td>{invoice.amount_money_type}</td>
                                <td><button className="btn btn-success" onClick={() => setAgree(invoice.id)}>Agree</button></td>
                                <td><button className="btn btn-danger" onClick={() => setDisagree(invoice.id)}>Disagree</button></td>
                                {is_reviewer && <td></td>}
                                {!is_reviewer && <td><button className="btn btn-secondary" onClick={() => setArchived(invoice.id)}>Archive</button></td>}
                                {!is_reviewer && <td><button className='btn btn-secondary' data-bs-toggle="modal" data-bs-target="#editInvoiceModal" onClick={() => editInvoiceData(invoice.id)}>Edit</button></td>}
                            </tr>
                        )
                    } else {
                        return (
                            <tr className='table-secondary' key={invoice.id}>
                                <th scope="row">{invoice.id} <input id={'invoiceCheckBox' + invoice.id} className="form-check-input invoices-check-box" type="checkbox" value="" onClick={() => checkBoxFired(invoice.id)}/></th>
                                <td>{invoice.employee}</td>
                                <td>{invoice.name}</td>
                                <td>{invoice.description}</td>
                                <td>{invoice.category}</td>
                                <td>{invoice.invoice_date}</td>
                                <td className='text-center'><button className="btn btn-dark" data-bs-toggle="modal" data-bs-target="#filesModal" onClick={() => getInvoiceFiles(invoice.id)}>Show Files</button></td>
                                <td className='text-end'>{financial(invoice.total_amount_of_invoice)}</td>
                                <td>{invoice.amount_money_type}</td>
                                <td><button className="btn btn-success" onClick={() => setAgree(invoice.id)}>Agree</button></td>
                                <td><button className="btn btn-danger" onClick={() => setDisagree(invoice.id)}>Disagree</button></td>
                                {is_reviewer && <td></td>}
                                {!is_reviewer && <td><button className="btn btn-secondary" onClick={() => setArchived(invoice.id)}>Archive</button></td> }
                                {!is_reviewer && <td><button className='btn btn-secondary' data-bs-toggle="modal" data-bs-target="#editInvoiceModal" onClick={() => editInvoiceData(invoice.id)}>Edit</button></td> }
                            </tr>
                        )
                    }
                    }
                    
                })}
            </tbody>

            </table>
            </div>
        </div>
        <div className='d-flex justify-content-center'>
            <nav aria-label="Page navigation example">
                <ul className="pagination">
                    {previousUrl && 
                        <li className="page-item"><button className='page-link' onClick={() => paginationHandler(previousUrl)}>Previous</button></li>
                    }

                    {nextUrl && 
                        <li className="page-item"><button className='page-link' onClick={() => paginationHandler(nextUrl)}>Next</button></li>
                    }
                </ul>
            </nav>
        </div>

        <EditInvoice invoiceToEdit={invoiceToEdit} patchInvoice={patchInvoice} invoiceToEditCategories={invoiceToEditCategories} />

        <div className="modal fade" id={"filesModal"} tabIndex="-1" aria-labelledby="filesModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-body">
                    <ul className=''>
                            {invoiceFiles.map(invoiceFile => (
                                <li key={invoiceFile.id}>
                                    <p><a target="_blank" href={baseURL + invoiceFile.invoice_file}><p>{invoiceFile.id} -- {invoiceFile.invoice_file.substring(1, 40)}</p></a></p>
                                </li>
                                
                            ))}
                    </ul>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EmployerPage